import { render, staticRenderFns } from "./TableMonthlyForecastIndex.vue?vue&type=template&id=71918278&scoped=true&"
import script from "./TableMonthlyForecastIndex.vue?vue&type=script&lang=js&"
export * from "./TableMonthlyForecastIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71918278",
  null
  
)

export default component.exports